<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" :rules="formRules">
      <el-form-item label="名称" prop="name" required>
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="form.type" @change="toggleType" style="width: 100%;">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="保存节点">
        <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false"
          :render-content="renderContent" :props="defaultLabel" />
      </el-form-item>

      <el-button type="primary" :disabled="!data.length" @click="submitData">确认</el-button>
      <el-button @click="cancel"> 取消</el-button>

    </el-form>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      data: [],
      form: {
        type: 1,
        name: '',
      },
      options: [
        { label: '个人搜索', value: 0 },
        { label: '全局搜索', value: 1 },
      ],
      selectItem: {},
      searchTree: {},
      defaultLabel: {
        label: 'name',
        value: 'id'
      },
      formRules: {
        name: [
          {
            required: true,
            message: this.$t("message.tips.inputName"),
            trigger: "blur",
          },
          {
            min: 3,
            max: 20,
            message: this.$t("message.warning.length_102"),
            trigger: "blur",
          },
        ],
      }
    }
  },
  methods: {
    submitData() {

      // if (!this.selectItem?.id) {
      //   this.$message.error('请选择保存节点');
      //   return
      // }
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const data = {
          ...this.form,
          "folderId": this.selectItem.id
        }
        this.$emit('submit', data)
      })

    },
    cancel() {
      this.$emit('cancel')
    },
    handleClick(node, data) {
      this.selectItem = data
    },
    renderContent(h, { node, data, store }) {
      return (
        <div class="custom-tree-node" style='display:flex;width:100%;align-items:center' on-click={() => this.handleClick(node, data)}>
          <div>{node.label}</div>
          <div class='btns' style="margin-left: auto;margin-right:15px">

          </div>
        </div>);
    },

    toggleType(e) {
      this.data = this.searchTree["p" + e];
      this.selectItem = this.data[0]
      console.log(this.selectItem);
      if (!this.data.length) {
        this.$message.error("请创建对应文件夹")
      }
    },
    getData() {
      axios.get(`/pmdm/folder/findSearchFolderTree`).then(res => {
        // console.log(res);
        const { globalFolderTree, personalFolderTree } = res.data.object;
        this.searchTree = { p1: globalFolderTree, p0: personalFolderTree };
        this.data = globalFolderTree
        this.selectItem = this.data[0]
      })
    },
  },
  created() {
    this.getData();
  }

}


</script>